import styled from "@emotion/styled";

export default styled.div`
  word-wrap: break-word;
  overflow-wrap: break-word;
  line-height: 1.6;
  color: ${(props) => props.theme.text.primary};
  font-size: 15px;

  pre {
    white-space: pre-wrap;
    background-color: ${(props) =>
      props.theme.type === "light"
        ? props.theme.gray.gray100
        : props.theme.gray.gray700};
    color: ${(props) =>
      props.theme.type === "dark"
        ? props.theme.blueGray.blueGray200
        : "inherit"};
    padding: 15px;
    border-radius: 8px;
    margin: 15px 0;
    border: 1px solid ${(props) => props.theme.borderColor};
    font-size: 14px;
  }

  code {
    background-color: ${(props) =>
      props.theme.type === "light"
        ? props.theme.gray.gray100
        : props.theme.gray.gray700};
    color: ${(props) =>
      props.theme.type === "dark"
        ? props.theme.blueGray.blueGray200
        : props.theme.primary};
    padding: 3px 6px;
    border-radius: 4px;
    font-size: 14px;
  }

  p {
    margin: 15px 0;
  }

  h1,
  h2,
  h3,
  h4,
  h5,
  h6 {
    margin-top: 28px;
    color: ${(props) => props.theme.text.primary};
  }

  a {
    color: ${(props) => props.theme.primary};
    text-decoration: none;

    &:hover {
      text-decoration: underline;
    }
  }

  ul,
  ol {
    padding-left: 24px;
    margin: 16px 0;
  }

  blockquote {
    border-left: 4px solid
      ${(props) =>
        props.theme.type === "light"
          ? props.theme.gray.gray300
          : props.theme.gray.gray700};
    padding-left: 16px;
    margin-left: 0;
    margin-right: 0;
    font-style: italic;
    color: ${(props) => props.theme.text.secondary};
  }

  table {
    border-collapse: collapse;
    width: 100%;
    margin: 16px 0;
    font-size: 14px;
    overflow-x: auto;
    display: block;

    th,
    td {
      border: 1px solid ${(props) => props.theme.borderColor};
      padding: 8px;
      text-align: left;
    }

    th {
      background-color: ${(props) =>
        props.theme.type === "light"
          ? props.theme.gray.gray100
          : props.theme.gray.gray800};
      font-weight: bold;
    }

    tr:nth-of-type(even) {
      background-color: ${(props) =>
        props.theme.type === "light"
          ? props.theme.gray.gray50
          : props.theme.gray.gray900};
    }
  }
`;
